import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api/client";
import "./AuthForm.css";

const SellerLogin = ({ onLogin }) => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ identifier: "", password: "" });
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    const identifier = form.identifier.trim();
    if (!identifier) {
      setError("Enter the seller login email created by super admin.");
      return;
    }

    try {
      const response = await api.post("/api/sellers/login", { ...form, identifier });
      const { token, seller } = response.data;
      const unified = {
        ...seller,
        id: seller.id || seller._id,
        token,
      };

      localStorage.setItem("seller-token", token);
      localStorage.setItem("seller", JSON.stringify(unified));
      localStorage.removeItem("customer");
      localStorage.removeItem("admin-token");

      if (onLogin) onLogin(unified);
      navigate("/seller/dashboard");
    } catch (err) {
      setError(err?.response?.data?.error || err?.response?.data?.message || "Login failed");
    }
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <h2>Seller Login</h2>
      <p>
        Seller accounts are created only by the super admin. Use the seller login email and password shared with that
        seller.
      </p>
      {error && <div className="message error">{error}</div>}
      <input
        type="text"
        autoComplete="username"
        placeholder="Seller login email, for example sellername@gmail.com"
        value={form.identifier}
        onChange={(event) => setForm((prev) => ({ ...prev, identifier: event.target.value }))}
        required
      />
      <input
        type="password"
        placeholder="Password"
        value={form.password}
        onChange={(event) => setForm((prev) => ({ ...prev, password: event.target.value }))}
        required
      />
      <button type="submit">Enter Seller Portal</button>
      <p style={{ fontSize: 13, color: "#64748b", marginBottom: 0 }}>
        Super admin? Use{" "}
        <Link to="/admin-login" style={{ color: "#0369a1", fontWeight: 800 }}>
          Super Admin Login
        </Link>
        .
      </p>
    </form>
  );
};

export default SellerLogin;
